/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    TEAM_CREATE_SUCCESS,
    TEAM_DETAIL_SUCCESS,
    TEAM_EDIT_SUCCESS,
    TEAM_LIST_SUCCESS
} from "../../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const TeamsReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case TEAM_LIST_SUCCESS:
            let teams = action.payload.data.data;

            teams.map((team) => {
                let id = team['id'];
                state[id] = team;
                return true;
            });

            return {...state, action};

        case TEAM_EDIT_SUCCESS:
        case TEAM_DETAIL_SUCCESS:
        case TEAM_CREATE_SUCCESS:
            let id = action.payload.data['id'];
            state[id] = action.payload.data;
            return {...state, action};
        default:
            return state;
    }
};

export {TeamsReducer}